// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterPropsActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { getOr, omit, curry } from 'lodash/fp';
import FilterDetails from 'logic/models/Izenda.FilterDetails';
import { toJS } from 'mobx';

const CANCEL = 'cancel';
const ACCEPT = 'accept';

/**
 * On close handle
 * @param {Object} props 
 * @param {Function} callBack 
 * @param {String} type 
 */
const onClosing = (props: any, callBack: any, type: string) => {
  const valManager = props.validation;
  const reportFilter = getOr({}, 'reportFields.reportFilter', props.reportDesignerModel);
  switch (type) {
    case ACCEPT:
      if (!reportFilter.configField.fieldDetails.checkDirty()) {
        props.onAccept();
        return;
      }
      valManager.validate().then(success => {
        if (success) {
          reportFilter.updateFilterFieldDetail();
          if (reportFilter.configField.isValueChangeFromPopup)
            props.fieldStore.updateReportDesignerCascadingFilter(reportFilter.configField.fieldDetails);
          props.onAccept();
        }
      });
      break;
    case CANCEL:
      valManager.reset();
      props.onReject();
      break;
  }
};

/**
 * Clone config field object
 * @param {Object} props 
 */
const cloneConfigField = (props: any) => () => {
  const reportFilter = getOr({}, 'reportFields.reportFilter', props.reportDesignerModel);
  const fieldDetail = omit(['filterItemDom', 'filterList'], reportFilter.configField.fieldDetails);

  props.reportDesignerModel.reportFields.reportFilter.setConfigModeToField(new FilterDetails(toJS(fieldDetail)));
};

export default withHandlers({
  onClosing: curry(onClosing),
  cloneConfigField
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.FilterPropsActions.js